export default "__VITE_ASSET__da18b62c__"